// @flow
import React, { Component } from "react";
// $FlowFixMe
import Rnd from "react-rnd";
import { PageMode, setPageMode } from "../../demo/src/GlobalParams";

import "../style/AreaHighlight.css";
import type { T_ViewportHighlight, T_LTWH } from "../types";

type Props = {
  highlight: T_ViewportHighlight,
  onChange: (rect: T_LTWH) => void,
  onClick: () => void
};

export default class AreaHighlight extends Component<Props> {
  constructor(props) {
    super(props);
    this.state = { dragging: false };
  }

  render() {
    const { highlight, onChange, onClick, ...otherProps } = this.props;
    let isSelected = this.props.selectedHighlightId == highlight.id;
    return (
      <Rnd
        disableDragging={PageMode == "Add"}
        className={`AreaHighlight ${isSelected ? "AreaHighlight--scrolledTo" : ""}`}
        enableUserSelectHack={false}
        onDragStop={(_, data) => {
          const boundingRect = {
            ...highlight.position.boundingRect,
            top: data.y,
            left: data.x
          };
          onChange(boundingRect);
          var refThis = this;
          setTimeout(function () { refThis.setState({ dragging: false }); }, 500);
        }}
        onDrag={(e) => {
          this.setState({ dragging: true });
        }}
        onResizeStop={(_, direction, ref, delta, position) => {
          const boundingRect = {
            top: position.y,
            left: position.x,
            width: ref.offsetWidth,
            height: ref.offsetHeight
          };

          onChange(boundingRect);
        }}
        position={{
          x: highlight.position.boundingRect.left,
          y: highlight.position.boundingRect.top
        }}
        size={{
          width: highlight.position.boundingRect.width,
          height: highlight.position.boundingRect.height
        }}
        {...otherProps}
      >
        <div className={`AreaHighlight--handle ${this.state.dragging ? "AreaHighlight--drag" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (PageMode == "ReadOnly") {
              onClick(highlight.id);
            }
          }}>
        </div>
      </Rnd>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AreaHighlight.js